import { OPEN_MODAL_OCC, CLOSE_MODAL_OCC } from "../action/modalOccActions";

const initialState = {
  isOpenModal: false,
  modalType: null,
};

const modalOccReducer = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_MODAL_OCC:
      return {
        ...state,
        isOpenModal: true,
        modalType: action.payload,
      };
    case CLOSE_MODAL_OCC:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default modalOccReducer;
